import type { DashboardKpiComparison } from '../types';

const MONTHS_DE = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember',
] as const;

function parseYmd(ymd: string): { y: number; m: number; d: number } | null {
  const parts = ymd.split('-').map((x) => Number.parseInt(x, 10));
  if (parts.length !== 3 || parts.some((n) => !Number.isFinite(n))) return null;
  const [y, m, d] = parts;
  return { y, m, d };
}

function formatYmdRange(from: string, to: string): string {
  const start = parseYmd(from);
  const end = parseYmd(to);
  if (!start || !end) return from;
  const monthLabel = MONTHS_DE[end.m - 1] ?? String(end.m);
  if (from === to) return `${end.d}. ${monthLabel} ${end.y}`;
  if (from.slice(0, 7) === to.slice(0, 7)) {
    return `${start.d}.–${end.d}. ${monthLabel} ${end.y}`;
  }
  const startMonth = MONTHS_DE[start.m - 1] ?? String(start.m);
  return `${start.d}. ${startMonth} – ${end.d}. ${monthLabel} ${end.y}`;
}

export function kpiComparisonCaption(comparison: DashboardKpiComparison): string {
  return `vs. ${formatYmdRange(comparison.previousFrom, comparison.previousTo)}`;
}
